<div class="container-fluid" style="padding:0">
    <div class="row">
        <div class="col-lg-2">
            <app-navbar></app-navbar>
        </div>
        <div class="col-lg-10">
            <div class="row">
                <div class="col-lg-9">
                    <br>
                    <h2>Paquetes</h2>
                </div>
                <div class="col-lg-2">
                    <br>
                    <button (click)="openModal(agregarModal)" type="button" class="boton fondoAmarillo blanco bold" > Agregar <svg width="1em" height="1em" viewBox="0 0 16 16" class="bi bi-plus-circle" fill="currentColor" xmlns="http://www.w3.org/2000/svg">
                        <path fill-rule="evenodd" d="M8 15A7 7 0 1 0 8 1a7 7 0 0 0 0 14zm0 1A8 8 0 1 0 8 0a8 8 0 0 0 0 16z"/>
                        <path fill-rule="evenodd" d="M8 4a.5.5 0 0 1 .5.5v3h3a.5.5 0 0 1 0 1h-3v3a.5.5 0 0 1-1 0v-3h-3a.5.5 0 0 1 0-1h3v-3A.5.5 0 0 1 8 4z"/>
                      </svg> </button>
                </div>
            </div>

            <div class="row">
                <div class="col-lg-11">
                    <br>
                    <table  class="table table-striped"    style="text-align: center;">
                        <thead class="thead-dark">
                            <tr>
                                <td>Nombre</td>
                                <td>Precio</td>
                                <td>Imagen</td>
                                <td>Categoria</td>
                                <td>Tipo</td>
                                <td>Productos</td>
                                <td>Editar</td>
                                <td>Activar/Desactivar</td>
                            </tr>
                        </thead>
                        <tbody>
                            <tr *ngFor="let paquete of paquetes">
                                <td>{{paquete.nombre}}</td>
                                <td>{{paquete.precio | currency}}</td>
                                <td><img src="{{environment}}{{paquete.imagen}}" width="200px"></td>
                                <td>{{paquete.categoria_nombre}}</td>
                                <td>{{paquete.tipo_paquete_nombre}}</td>
                                <td><button class="btn btn-success" (click)="getDetallePaquete(paquete.id)">Ver Productos</button></td>
                                <td><a (click)="editarPaquete(paquete.id)">
                                    <svg  style="color:gray" width="1em" height="1em" viewBox="0 0 16 16" class="bi bi-pencil-fill" fill="currentColor" xmlns="http://www.w3.org/2000/svg">
                                        <path fill-rule="evenodd" d="M12.854.146a.5.5 0 0 0-.707 0L10.5 1.793 14.207 5.5l1.647-1.646a.5.5 0 0 0 0-.708l-3-3zm.646 6.061L9.793 2.5 3.293 9H3.5a.5.5 0 0 1 .5.5v.5h.5a.5.5 0 0 1 .5.5v.5h.5a.5.5 0 0 1 .5.5v.5h.5a.5.5 0 0 1 .5.5v.207l6.5-6.5zm-7.468 7.468A.5.5 0 0 1 6 13.5V13h-.5a.5.5 0 0 1-.5-.5V12h-.5a.5.5 0 0 1-.5-.5V11h-.5a.5.5 0 0 1-.5-.5V10h-.5a.499.499 0 0 1-.175-.032l-.179.178a.5.5 0 0 0-.11.168l-2 5a.5.5 0 0 0 .65.65l5-2a.5.5 0 0 0 .168-.11l.178-.178z"/>
                                    </svg>
                                </a></td>
                                <td>
                                    <div *ngIf="paquete.activo == 1">
                                        <button class="btn btn-danger" (click)="desactivar(paquete.id)">Desactivar</button>
                                    </div>

                                    <div *ngIf="paquete.activo == 0">
                                        <button class="btn btn-success" (click)="activar(paquete.id)">Activar</button>
                                    </div>
                                </td>
                            </tr>
                        </tbody>
                    </table>
                </div>
            </div>
        </div>
    </div>
    <br><br>
</div>


<ng-template #agregarModal let-c="close" let-d="dismiss">
    <div class="modal-header">
        <h2>Agregar Paquete</h2>
      <button type="button" class="close" (click)="dismissAll()" data-dismiss="modal">&times;</button>
    </div>

    <div class="modal-body">
        <input type="text" class="form-control" placeholder="Nombre" [(ngModel)]="formulario.nombre"><br>
        <input type="text" class="form-control" placeholder="Precio" [(ngModel)]="formulario.precio"><br>
        <select class="form-control" [(ngModel)]="formulario.categoria">
            <option value="">Seleccione Categoría</option>
            <option *ngFor="let categoria of categorias" [value]="categoria.id">{{categoria.nombre}}</option>
        </select><br>
        <!-- <span class="bold">Categorías</span>
        <div class="col-3" *ngFor="let categoria of categorias">
            <input type="checkbox" (click)="seleccionarCategoria(categoria.id, $event);">
            {{categoria.nombre}}
        </div> -->
        <select class="form-control" [(ngModel)]="formulario.tipo_paquete">
            <option value="">Seleccione Tipo de Paquete</option>
            <option *ngFor="let tipoPaquete of tiposPaquete" [value]="tipoPaquete.id">{{tipoPaquete.nombre}}</option>
        </select><br>
        Imagen:<br>
        <input (change)="imageChange($event.target.files)" type="file"accept="image/*" id="imagen"><br><br>
    </div>

    <div class="modal-footer">
        <button class="btn btn-primary" (click)="agregarPaquete()">Agregar Paquete</button>
    </div>
</ng-template>


<div id="clickEditar" (click)="openModal(myModalEditar)"></div>

<ng-template #myModalEditar let-c="close" let-d="dismiss">
    <div class="modal-header">
        <h2>Editar Paquete</h2>
      <button type="button" class="close" (click)="dismissAll()" data-dismiss="modal">&times;</button>
    </div>

    <div class="modal-body">
        <input type="text" class="form-control" placeholder="Nombre" [(ngModel)]="formularioEdit.nombre"><br>
        <input type="text" class="form-control" placeholder="Precio" [(ngModel)]="formularioEdit.precio"><br>
        <select class="form-control" [(ngModel)]="formularioEdit.categoria">
            <option value="">Seleccione Categoría</option>
            <option *ngFor="let categoria of categorias" [value]="categoria.id">{{categoria.nombre}}</option>
        </select><br>

        <select class="form-control" [(ngModel)]="formularioEdit.tipo_paquete">
            <option value="">Seleccione Tipo de Paquete</option>
            <option *ngFor="let tipoPaqueteE of tiposPaquete" [value]="tipoPaqueteE.id">{{tipoPaqueteE.nombre}}</option>
        </select><br>
        <img src="{{environment}}{{imagenActual}}" height="300px"><br>
        Imagen:<br>
        <input (change)="imageChangeEdit($event.target.files)" type="file"accept="image/*" id="imagen2"><br><br>

        <br>
        <h3>Configuración General</h3>
        <p>Por favor elige los elementos que contiene este paquete, estos se verán reflejados en la 
            selección del perfil de usuario.
        </p>
        <div class="row">
            <div class="col-6">
                <span class="bold">Marco:</span>
                <select class="form-control" [(ngModel)]="formularioEdit.marco">
                    <option value="">Selecciona Opción</option>
                    <option value="1">Sí</option>
                    <option value="0">No</option>
                </select>

                <span class="bold">Color Marco:</span>
                <select class="form-control" [(ngModel)]="formularioEdit.color_marco">
                    <option value="">Selecciona Opción</option>
                    <option value="1">Sí</option>
                    <option value="0">No</option>
                </select>


                <span class="bold">Placa:</span>
                <select class="form-control" [(ngModel)]="formularioEdit.placa">
                    <option value="">Selecciona Opción</option>
                    <option value="1">Sí</option>
                    <option value="0">No</option>
                </select>

                <span class="bold">Color Placa:</span>
                <select class="form-control" [(ngModel)]="formularioEdit.color_placa">
                    <option value="">Selecciona Opción</option>
                    <option value="1">Sí</option>
                    <option value="0">No</option>
                </select>

                <span class="bold">Diploma:</span>
                <select class="form-control" [(ngModel)]="formularioEdit.diploma">
                    <option value="">Selecciona Opción</option>
                    <option value="1">Sí</option>
                    <option value="0">No</option>
                </select>

                <span class="bold">Agradecimiento:</span>
                <select class="form-control" [(ngModel)]="formularioEdit.agradecimiento">
                    <option value="">Selecciona Opción</option>
                    <option value="1">Sí</option>
                    <option value="0">No</option>
                </select>

                <span class="bold">Diploma o Agradecimiento:</span>
                <select class="form-control" [(ngModel)]="formularioEdit.diploma_agradecimiento">
                    <option value="">Selecciona Opción</option>
                    <option value="1">Sí</option>
                    <option value="0">No</option>
                </select>

                <span class="bold">Texto:</span>
                <select class="form-control" [(ngModel)]="formularioEdit.texto">
                    <option value="">Selecciona Opción</option>
                    <option value="1">Sí</option>
                    <option value="0">No</option>
                </select>

                <span class="bold">Anillo:</span>
                <select class="form-control" [(ngModel)]="formularioEdit.anillo">
                    <option value="">Selecciona Opción</option>
                    <option value="1">Sí</option>
                    <option value="0">No</option>
                </select>

                <span class="bold">Personalizador:</span>
                <select class="form-control" [(ngModel)]="formularioEdit.personalizador">
                    <option value="">Selecciona Opción</option>
                    <option value="1">Sí</option>
                    <option value="0">No</option>
                </select>
            </div>
        </div>
    </div>

    <div class="modal-footer">
        <button class="btn btn-primary" (click)="updatePaquete(paqueteid)">Actualizar Paquete</button>
    </div>
</ng-template>



<div id="clickPaquete" (click)="openModal(mymodal2)"></div>
<ng-template #mymodal2 let-c="close" let-d="dismiss">
    <div class="modal-header">
      <h4 class="modal-title" id="modal-basic-title">Paquete</h4>
      <button type="button" class="close" aria-label="Close" (click)="dismissAll()">
        <span aria-hidden="true">×</span>
      </button>
    </div>
    <div class="modal-body">
        <h5>Detalles de Paquete</h5>
       
        <table>
            <tr *ngFor="let producto of detallePaquete">
                <td>
                    <p>{{producto.nombre}}</p>
                </td>
                <td>
                    <p>
                        <a (click)="eliminarProductoPaquete(producto.id, paqueteid)">
                     <svg style="color: red;" width="1em" height="1em" viewBox="0 0 16 16" class="bi bi-x-circle" fill="currentColor" xmlns="http://www.w3.org/2000/svg">
                         <path fill-rule="evenodd" d="M8 15A7 7 0 1 0 8 1a7 7 0 0 0 0 14zm0 1A8 8 0 1 0 8 0a8 8 0 0 0 0 16z"/>
                         <path fill-rule="evenodd" d="M4.646 4.646a.5.5 0 0 1 .708 0L8 7.293l2.646-2.647a.5.5 0 0 1 .708.708L8.707 8l2.647 2.646a.5.5 0 0 1-.708.708L8 8.707l-2.646 2.647a.5.5 0 0 1-.708-.708L7.293 8 4.646 5.354a.5.5 0 0 1 0-.708z"/>
                       </svg>
                    </a>
                </p>
                 </td>
            </tr>
        </table>


        <br><br>
      <span class="bold">Agregar Producto</span>
      <select #productoSelect class="form-control">
          <option value="">Seleccione Producto</option>
          <option *ngFor="let producto of productos" [value]="producto.id">{{producto.nombre}}</option>
      </select>
      <button class="btn btn-danger" (click)="agregarProductoPaquete(productoSelect.value, paqueteid)">Agregar</button><br>
    </div>
    <div class="modal-footer">
       

    </div>
  </ng-template>